import { Action } from 'redux';

import { AUTHORIZATION_REQUEST, AUTHORIZATION_RESPONSE, AUTHORIZATION_ERROR, RESET_AUTHORIZATION, RESET_SEND_CODE_AUTHORIZATION } from '../../actions/Authorization/authorization';
import { AUTHORIZATION_SEND_CODE_REQUEST, AUTHORIZATION_SEND_CODE_RESPONSE, AUTHORIZATION_SEND_CODE_ERROR } from '../../actions/Authorization/authorization';
import { REFRESH_TOKEN_REQUEST, REFRESH_TOKEN_RESPONSE, REFRESH_TOKEN_ERROR } from '../../actions/Authorization/authorization';

export interface AuthorizationState {
    authorization: boolean;
    loadingAuthorization: boolean;
    errorAuthorization: {
        messages: string[];
        code: number;
    } | null;
    metaAuthorization: {
        timeout: number;
    } | null;

    sendCodeAuthorization: boolean;
    loadingSendCodeAuthorization: boolean;
    errorSendCodeAuthorization: {
        messages: string[];
        code: number;
    } | null;
    tariffId: number;

    refreshToken: boolean;
    loadingRefreshToken: boolean;
    errorRefreshToken: any;
    isFirebaseAuth: boolean;
}

const initialState: AuthorizationState = {
    authorization: false,
    loadingAuthorization: false,
    errorAuthorization: null,
    metaAuthorization: null,

    sendCodeAuthorization: false,
    loadingSendCodeAuthorization: false,
    errorSendCodeAuthorization: null,
    tariffId: 0,

    refreshToken: false,
    loadingRefreshToken: false,
    errorRefreshToken: null,
    isFirebaseAuth: false
};

export function authorizationState(state: AuthorizationState = initialState, action: Action) {
    switch (action.type) {
        case RESET_AUTHORIZATION: {
            return {
                ...state,
                authorization: initialState.authorization,
                loadingAuthorization: initialState.loadingAuthorization,
                errorAuthorization: initialState.errorAuthorization,
                metaAuthorization: initialState.metaAuthorization,
            };
        }
        case RESET_SEND_CODE_AUTHORIZATION: {
            return {
                ...state,
                sendCodeAuthorization: initialState.sendCodeAuthorization,
                loadingSendCodeAuthorization: initialState.loadingSendCodeAuthorization,
                errorSendCodeAuthorization: initialState.errorSendCodeAuthorization,
            };
        }
        case AUTHORIZATION_REQUEST: {
            return {
                ...initialState,
                loadingAuthorization: true,
            };
        }
        case AUTHORIZATION_RESPONSE: {
            const response = (action as any).response;
            if (response.result) {
                return {
                    ...state,
                    loadingAuthorization: false,
                    authorization: true,
                    isFirebaseAuth: !!response.result.is_firebase_auth
                };
            } else {
                return {
                    ...state,
                    loadingAuthorization: false,
                    errorAuthorization: response.error,
                    metaAuthorization: response.meta
                };
            }
        }
        case AUTHORIZATION_ERROR: {
            const error = (action as any).error;
            let errorAuthorization = error.error || null;
            const metaAuthorization = error.meta || null;
            if (errorAuthorization === 'ActiveRecord::RecordNotFound') {
                errorAuthorization = {
                    code: 7
                };
            }
            return {
                ...state,
                loadingAuthorization: false,
                errorAuthorization,
                metaAuthorization,
            };
        }
        case AUTHORIZATION_SEND_CODE_REQUEST: {
            return {
                ...state,
                loadingSendCodeAuthorization: true,
                sendCodeAuthorization: initialState.sendCodeAuthorization,
                errorSendCodeAuthorization: initialState.errorSendCodeAuthorization,
            };
        }
        case AUTHORIZATION_SEND_CODE_RESPONSE: {
            const response = (action as any).response;
            localStorage.setItem('auth', JSON.stringify(response.result));
            localStorage.setItem('KON_USER_ID', response.result.token);
            return {
                ...state,
                loadingSendCodeAuthorization: false,
                sendCodeAuthorization: true,
                tariffId: response.result.tariff_id
            };
        }
        case AUTHORIZATION_SEND_CODE_ERROR: {
            const error = (action as any).error;
            const errorSendCodeAuthorization = error.error || null;
            return {
                ...state,
                loadingSendCodeAuthorization: false,
                errorSendCodeAuthorization,
            };
        }
        case REFRESH_TOKEN_REQUEST: {
            return {
                ...state,
                loadingRefreshToken: true,
                refreshToken: initialState.refreshToken,
                errorRefreshToken: initialState.errorRefreshToken,
            };
        }
        case REFRESH_TOKEN_RESPONSE: {
            const response = (action as any).response;
            localStorage.setItem('auth', JSON.stringify(response.result));
            if (response.result.token) {
                localStorage.setItem('KON_USER_ID', response.result.token);
            }
            return {
                ...state,
                loadingRefreshToken: false,
                refreshToken: true,
                tariffId: response.result.tariff_id
            };
        }
        case REFRESH_TOKEN_ERROR: {
            const errorRefreshToken = (action as any).error;
            return {
                ...state,
                loadingRefreshToken: false,
                errorRefreshToken,
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Authorization/authorization.ts